import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const quartileDescription: CalculatorDescription = {
  id: CalculatorId.QUARTILE,
  title: 'Quartile calculator',
  metaTitle: 'Quartile Calculator - Find Data Distribution Quarters',
  description: 'Calculate quartiles to divide your dataset into four equal parts.',
  metaDescription: 'Free online quartile calculator. Find Q1, Q2, and Q3 values to understand your data distribution with our easy-to-use statistical tool.',
  howTo: {
    title: 'How to calculate quartiles',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically determine the first quartile (Q1), second quartile (Q2, median), and third quartile (Q3)',
      'View the interquartile range (IQR) which is Q3 - Q1',
      'Examine the visualization to see how your data is distributed across quartiles'
    ],
    graphic: {
      description: 'Visual representation of quartile calculation'
    }
  },
  examples: [
    {
      title: 'Finding quartiles in test scores',
      description: 'Analyzing student performance distribution by quarters',
      dataDescription: 'Test scores from a class of 20 students',
      insights: [
        'Q1 (25th percentile) is 75, meaning 25% of scores are below 75',
        'Q2 (50th percentile, median) is 82',
        'Q3 (75th percentile) is 88, meaning 75% of scores are below 88',
        'The interquartile range (IQR) is 13 points (88 - 75)',
        'Quartiles help identify the spread and central tendency of data'
      ],
      data: TableDataJSON.from({
        columns: [
          { 
            id: 'scores',
            name: 'Test Scores', 
            values: ['65', '70', '72', '75', '75', '76', '78', '80', '80', '82', '82', '83', '85', '85', '86', '88', '90', '92', '95', '98'] 
          }
        ]
      })
    }
  ],
  relatedCalculators: [
    CalculatorId.PERCENTILE,
    CalculatorId.MEDIAN,
    CalculatorId.BoxPlot
  ]
}; 